<template>
  <div class="level-selector-wrap d-flex flex-column flex-lg-row mt-5">
    <div class="level-selector d-flex flex-column">

      <div class="dropdown">
        <button id="dropdown-1-btn" class="dropdown-toggle d-flex justify-content-between align-items-center w-100" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <span v-html="selectedMarriottLevel.title"></span>
          <img src="/images/icon_caret-down.png" class="arrow" alt="">
        </button>
        <div class="dropdown-menu w-100" aria-labelledby="dropdown-1-btn">
          <div class="d-flex flex-column align-items-start">
            <button v-for="(level, index) in marriottLevels" :key="index" class="option w-100" @click="selectMarriottlevel(index)" @keydown.enter="selectMarriottlevel(index)" v-html="level.title"></button>
          </div>
        </div>
      </div>

      <div class="dropdown disabled" ref="milesAndMoreDropdown">
        <button id="dropdown-2-btn" class="dropdown-toggle d-flex justify-content-between align-items-center w-100" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <span v-html="selectedMilesAndMoreLevel.title"></span>
          <img src="/images/icon_caret-down.png" class="arrow" alt="">
        </button>
        <div class="dropdown-menu w-100" aria-labelledby="dropdown-2-btn">
          <div class="d-flex flex-column align-items-start">
            <button v-for="(level, index) in milesAndMoreLevels" :key="index" class="option w-100" @click="selectMilesAndMorelevel(index)" @keydown.enter="selectMilesAndMorelevel(index)" v-html="level.title"></button>
          </div>
        </div>
      </div>

      <div class="switch-wrap d-flex align-items-center">
        <p id="switch-label" class="text-left fz-3xs mr-3 mb-0" v-html="content.switch_label"></p>
        <label class="switch d-flex mb-0">
          <div>
            <input @input="onCardStatusInput" type="checkbox" aria-labelledby="switch-label">
            <span class="slider round"></span>
          </div>
        </label>
        <p class="fz-2xs ml-1">{{ hasCard }}</p>
      </div>

    </div> <!-- .level-selector -->

    <div :class="`benefits ${benefitsElClass} bg-white`">
      <div v-if="showResults" class="results text-center">

        <h3 class="subheading-2 mb-2" v-html="content.results_heading"></h3>
        <p class="fz-sm" style="line-height: 1.5;" v-html="content.results_body"></p>

        <!-- <ul class="three-up mb-4 mb-sm-2 mt-2 ml-0">
          <li v-for="(item, index) in content.results_three_up" :class="`module module-${index + 1} text-center d-flex flex-column`" :key="index">
            <h3 class="heading number">{{ item.number }}</h3>
            <p v-html="item.body"></p>
          </li>
        </ul>
        <a href="#" class="link-1" data-toggle="modal" data-target="#view-all-brands-modal">{{ content.view_all_brands }}</a> -->

        <div v-if="results[resultsKey].silver_status" class="dynamic-section">
          <h3 class="subheading-2 mb-2" v-html="results[resultsKey].silver_status.heading"></h3>
          <p v-for="(item, index) in results[resultsKey].silver_status.body" v-html="item" :key="index"></p>
          <ul v-if="results[resultsKey].silver_status.list" class="benefits-three-up">
            <li v-for="(item, index) in results[resultsKey].silver_status.list" :key="index">
              <img :src="item.img_src" alt="">
              <p v-html="item.copy"></p>
            </li>
          </ul>
        </div>

        <div v-if="results[resultsKey].gold_accelerator" class="dynamic-section">
          <h3 class="subheading-2 mb-2" v-html="results[resultsKey].gold_accelerator.heading"></h3>
          <p v-for="(item, index) in results[resultsKey].gold_accelerator.body" v-html="item" :key="index"></p>
          <ul v-if="results[resultsKey].gold_accelerator.list" class="benefits-three-up">
            <li v-for="(item, index) in results[resultsKey].gold_accelerator.list" :key="index">
              <img :src="item.img_src" alt="">
              <p v-html="item.copy"></p>
            </li>
          </ul>
        </div>

        <div v-if="results[resultsKey].gold_status" class="dynamic-section">
          <h3 class="subheading-2 mb-2" v-html="results[resultsKey].gold_status.heading"></h3>
          <p v-for="(item, index) in results[resultsKey].gold_status.body" v-html="item" :key="index"></p>
          <ul v-if="results[resultsKey].gold_status.list" class="benefits-three-up">
            <li v-for="(item, index) in results[resultsKey].gold_status.list" :key="index">
              <img :src="item.img_src" alt="">
              <p v-html="item.copy"></p>
            </li>
          </ul>
        </div>

      </div> <!-- .results-->
      <p v-else v-html="content.results_placeholder"></p>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { q } from '../utilities';

const content = APP_content;
const results = content.results;
const selectedMarriottLevel = ref(APP_content.marriott_levels_placeholder);
const marriottLevels = APP_content.marriott_levels;
const selectedMilesAndMoreLevel = ref(APP_content.miles_and_more_levels_placeholder);
const milesAndMoreLevels = APP_content.miles_and_more_levels;
const resultsKey = ref('');
const cardStatusKey = ref('noCard');
const hasCard = ref(APP_content.no);
const benefitsElClass = ref('');
const milesAndMoreDropdown = ref(null);
let bgImgEl;

function selectMarriottlevel(i) {
  selectedMarriottLevel.value = marriottLevels[i];
  milesAndMoreDropdown.value.classList.remove('disabled');
}

function selectMilesAndMorelevel(i) {
  selectedMilesAndMoreLevel.value = milesAndMoreLevels[i];
}

const showResults = computed(() => {
  const marriottKey = selectedMarriottLevel.value.key;
  const milesMoreKey = selectedMilesAndMoreLevel.value.key;
  resultsKey.value = `${marriottKey}_${milesMoreKey}_${cardStatusKey.value}`;
  if (marriottKey && milesMoreKey) {
    benefitsElClass.value = 'show-results';
    bgImgEl.classList.add('show-results');
    return true;
  }
});

function onCardStatusInput() {
  hasCard.value = hasCard.value === APP_content.no ? APP_content.yes : APP_content.no;
  if (hasCard.value === APP_content.yes) {
    cardStatusKey.value = 'hasCard';
  } else {
    cardStatusKey.value = 'noCard';
  }
}

onMounted(() => {
  bgImgEl = q('.section-2');
});
</script>

<style lang="scss" scoped>
@import 'resources/styles/variables';
@import 'resources/styles/mixins';

.level-selector {
  flex: 0 0 37%;
  margin-right: 60px;
  .dropdown {
    margin-bottom: 30px;
    @media #{$mxw-sm} {
      margin-bottom: 24px;
    }
  }
  @media #{$mxw-lg} {
    margin-right: 0;
    margin-bottom: 25px;
  }
}
.switch-wrap {
  background-color: #fff;
  border-radius: 9px;
  padding: 8px 12px;
}
#app .dynamic-section {
  position: relative;
  margin-top: 30px;
  padding-top: 25px;
  &:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 1px;
    background-color: $color-1;
  }
  &:last-of-type {
    &:before {
      width: 250px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  > p {
    margin-bottom: 6px;
  }
}
#app .dropdown.disabled {
  border-radius: 9px;
  .dropdown-toggle {
    background-color: #eee;
  }
}
</style>
